<template lang="pug">
  v-content
    v-container.grey.lighten-4
      v-row
        v-col
          pageTitle {{ $route.name }}
    v-container.indigo.lighten-5.text-center
      v-card
        v-card-text
          v-form(v-model="isValid")
            v-row
              v-col(cols=10)
                v-text-field(label="フリガナ" v-model="customer.kana" :rules="[required]")
            v-row
              v-col(cols=10)
                v-text-field(label="お得意先名" v-model="customer.name"
                  :rules="[required]" @blur="cp2label"
                )
            v-row
              v-col(cols=6)
                v-textarea(rows=3 label="ラベル (伝票に表示する内容)"
                  :rules="[required]" v-model="customer.label"
                )
              v-col(cols=2 align-baseline)
                v-combobox(label="敬称" v-model="customer.keisyo" :items="keisyos")
                v-text-field(label="締日" v-model="customer.shimebi")
              v-col(cols=4)
                v-select(label="入金先口座" :items="bank_accounts"
                  v-model="customer.bank_account_id"
                  item-text="bank_name" item-value="id" :rules="[required]"
                )
                | {{ bastr() }}
            v-row
              v-col(cols=2)
                v-text-field(label="郵便番号" v-model="customer.zip")
              v-col
                v-text-field(label="住所" v-model="customer.address")
            v-row
              v-col
                v-text-field(label="電話番号" v-model="customer.phone")
              v-col
                v-text-field(label="FAX" v-model="customer.fax")
            v-row
              v-col
                v-textarea(rows=2 label="備考" v-model="customer.note")
        v-card-actions
          v-spacer
          v-btn(
            color="primary" width="100" @click="edit_save" :disabled="!isValid"
          ) 保存
          v-spacer
          v-btn(@click="edit_cancel") キャンセル
          v-spacer
</template>

<script>
  import debugLog from '@/utils/debugLog'
  import { getCustomer, patchCustomer, postCustomer } from '@/api/customer'
  import { getBankAccounts } from '@/api/bank_account'
  import pageTitle from '@/components/pageTitle'
  import { bank_account2str } from '@/utils/helpers'

  export default {
    name: 'CustomerShow',
    components: {pageTitle},
    data() {return {
      customer: {kana: '', name: '', keisyo: '', label: '', bank_account_id: '',
        hide: false, zip: '', phone: '', address: '', note: '', shimebi: 20
      },
      bank_accounts: [],
      keisyos: ["御中", "様", "殿"],
      isValid: true
    }},
    created() {
      const self = this
      if (!this.$route.params.id) {
        getBankAccounts().then((res) => {
          self.bank_accounts = Object.assign([], res.data.data)
        })
        return
      }
      getCustomer(self.$route.params.id).then((res) => {
        self.customer = res.data
        if (res.data.bank_account_id) {
          getBankAccounts().then((res) => {
            self.bank_accounts = Object.assign([], res.data.data)
          })
        }
      })
    },
    methods: {
      required: value => value ? false : '入力が必要な項目です',
      cp2label() {
        if (!this.customer.label)
          this.customer.label = this.customer.name
      },
      bastr() {
        const ba_id = this.customer.bank_account_id
        const ba = this.bank_accounts.find(item => item.id === ba_id)
        return bank_account2str(ba)
      },
      edit_save() {
        const cid = this.customer.id
        const self = this
        if (cid) {
          patchCustomer(this.customer).then(res => {
            debugLog(res)
            self.$router.push(`/customers/show/${cid}`)
          }, err => {
            debugLog(err)
          })
        } else {
          postCustomer(this.customer).then(res => {
            debugLog(res)
            self.$router.push(`/customers/show/${res.data.id}`)
          }, err => {
            debugLog(err)
          })
        }
      },
      edit_cancel() {
        this.$router.back()
      }
    }
  }
</script>
